import React from 'react';

import {NO_DATA_AVAILABLE} from 'src/constants';

import {Dialog, DialogHeader, DialogMain} from '@pb/kit-component-dialog-v2';
import {Group, Item} from '@pb/kit-component-group';
import {Scrollable} from '@pb/kit-component-scrollable';

import {eventReviewTrigger, eventReviewTriggerText, eventReviewTriggerWrapper} from '../event-review.module.styl';

type Props = {
    caption: string,
    actualValue?: string,
    changeRequestValue?: string,
    shown: boolean,
    setShown: (shown: boolean) => void,
    onClose: () => void,
};

export const CompareChangesModal = (props: Props) => {
    const {
        caption,
        actualValue,
        changeRequestValue,
        shown,
        setShown,
        onClose,
    } = props;

    return (
        <Dialog shown={shown} setShown={setShown} floatingOverlayProps={{lockScroll: false}}>
            <Group direction="v" style={{minWidth: 800}}>
                <DialogHeader onClose={onClose}>{caption}</DialogHeader>
                <DialogMain>
                    <Group gap="none">
                        <Item style={{width: '50%'}} className="pdy-l pl-l pr-sm">
                            <Group direction="v">
                                <strong>Actual used</strong>
                                <Item className={`${eventReviewTrigger} pt-s pl-s pr-s pb-s`} style={{width: '100%'}}>
                                    <div className={eventReviewTriggerWrapper}>
                                        <Scrollable>
                                            <div className={eventReviewTriggerText}>
                                                {actualValue || NO_DATA_AVAILABLE}
                                            </div>
                                        </Scrollable>
                                    </div>
                                </Item>
                            </Group>
                        </Item>
                        <Item style={{width: '50%'}} className="pdy-l pr-l pl-sm">
                            <Group direction="v">
                                <strong>Change request</strong>
                                <Item className={`${eventReviewTrigger} pt-s pl-s pr-s pb-s`} style={{width: '100%'}}>
                                    <div className={eventReviewTriggerWrapper}>
                                        <Scrollable>
                                            <div className={eventReviewTriggerText}>
                                                {changeRequestValue || NO_DATA_AVAILABLE}
                                            </div>
                                        </Scrollable>
                                    </div>
                                </Item>
                            </Group>
                        </Item>
                    </Group>
                </DialogMain>
            </Group>
        </Dialog>
    );
};

CompareChangesModal.defaultProps = {
    caption: 'Compare changes',
};
